/* Native details remain usable without JavaScript. No product/cart data changes. */
(() => {
  'use strict';
  const init = header => {
    if (!header || header.dataset.pwNavReady) return;
    header.dataset.pwNavReady = 'true';
    const drawer = header.querySelector('[data-pw-drawer]');
    const toggle = drawer?.querySelector(':scope > summary');
    const mobile = window.matchMedia('(max-width: 900px)');
    const position = () => {
      if (!drawer?.open) return;
      const row = header.querySelector('.pw-header-inner');
      const logo = header.querySelector('.pw-logo');
      // Keep the logo/menu controls visible while the panel covers search and page.
      const top = Math.max(0, logo.getBoundingClientRect().bottom + 14);
      header.style.setProperty('--pw-drawer-top', `${Math.min(top, row.getBoundingClientRect().bottom)}px`);
    };
    const closeDrawer = (focus = false) => {
      if (!drawer) return;
      drawer.open = false;
      drawer.querySelectorAll('details[open]').forEach(el => { el.open = false; });
      document.body.classList.remove('pw-menu-open');
      if (focus) toggle.focus();
    };
    drawer?.addEventListener('toggle', () => {
      document.body.classList.toggle('pw-menu-open', drawer.open && mobile.matches);
      if (drawer.open) position();
      else drawer.querySelectorAll('details[open]').forEach(el => { el.open = false; });
    });
    header.querySelector('[data-pw-menu-close]')?.addEventListener('click', () => closeDrawer(true));
    header.querySelectorAll('.pw-category-menu').forEach(menu => {
      menu.addEventListener('toggle', () => {
        if (!menu.open) return;
        const nav = menu.closest('nav');
        nav?.querySelectorAll('.pw-category-menu[open]').forEach(other => { if (other !== menu) other.open = false; });
      });
    });
    header.addEventListener('click', event => {
      if (event.target.closest('a') && drawer?.open) closeDrawer();
    });
    // Close only the innermost disclosure and restore focus. Supersedes the older
    // generic Escape handler, which closed every ancestor and moved focus twice.
    document.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const opened = [...header.querySelectorAll('details[open]')];
      if (!opened.length) return;
      const target = opened.reverse().find(el => el.contains(document.activeElement)) || opened[0];
      event.preventDefault(); event.stopImmediatePropagation();
      target.open = false;
      if (target === drawer) closeDrawer(true);
      else target.querySelector(':scope > summary')?.focus();
    }, true);
    // A disclosure must not stay open off-screen after keyboard focus leaves it.
    header.addEventListener('focusout', () => {
      requestAnimationFrame(() => {
        header.querySelectorAll('.pw-category-menu[open]').forEach(el => {
          if (!el.contains(document.activeElement)) el.open = false;
        });
        if (drawer?.open && !drawer.contains(document.activeElement)) closeDrawer();
      });
    });
    mobile.addEventListener('change', () => { closeDrawer(); header.querySelectorAll('.pw-category-menu[open]').forEach(el => { el.open = false; }); });
    window.addEventListener('resize', position, {passive:true});
    const switcher = document.querySelector('.pw-category-switch');
    if (switcher && mobile.matches) switcher.open = false;
  };
  init(document.querySelector('#pw-navigation'));
  document.addEventListener('shopify:section:load', () => init(document.querySelector('#pw-navigation')));
})();
